import { useLocation } from 'react-router';
import { useAlert } from '../contexts/AlertContext';
import { useCreateBillingPortalSessionMutation } from '../generated/graphql';

export const useBillingSession = () => {
  const [createBillingSessionResponse, createBillingSession] =
    useCreateBillingPortalSessionMutation();

  const { pathname } = useLocation();
  const alert = useAlert();
  const navigateToBillingPortal = () => {
    createBillingSession({ input: { returnPath: pathname } }).then(
      (response) => {
        if (response.data?.createPortalSession?.url) {
          window.location.href = response.data?.createPortalSession?.url;
          return;
        }
        if (response.error) {
          alert(response.error.message, 'danger');
        }
      },
    );
  };

  return {
    navigateToBillingPortal,
    loading: createBillingSessionResponse.fetching,
  };
};
